import { ChemicalCreateRequest } from '../request-models/chemical-create-request.model';
import { ChemicalUpdateRequest } from '../request-models/chemical-update-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * Builds the PUT /admin/chemicals/:id body. Copies only the hub's CHEMICAL_WRITABLE fields (never ids,
 * `source`, archive or timestamp fields), and only the ones that are set. `null` (clear the field) is kept.
 */
export function toChemicalRequest(fields: ChemicalUpdateRequest): ChemicalUpdateRequest {
  return omitUndefined<ChemicalUpdateRequest>({
    name: fields.name,
    category: fields.category,
    signalWord: fields.signalWord,
    epaNumber: fields.epaNumber,
    manufacturer: fields.manufacturer,
    activeIngredient: fields.activeIngredient,
    formulation: fields.formulation,
    defaultRate: fields.defaultRate,
    rei: fields.rei,
    phi: fields.phi,
    targetPests: fields.targetPests,
    crops: fields.crops,
    sponsorId: fields.sponsorId,
    sponsorName: fields.sponsorName,
    sponsorLogoUrl: fields.sponsorLogoUrl,
    sponsorWebsite: fields.sponsorWebsite,
    sponsorPhone: fields.sponsorPhone,
    sponsorEmail: fields.sponsorEmail,
    isFeatured: fields.isFeatured,
    specialOffer: fields.specialOffer,
    compareTo: fields.compareTo,
    rupFlag: fields.rupFlag,
    sdsUrl: fields.sdsUrl,
    productUrl: fields.productUrl,
  });
}

/**
 * Builds the POST /admin/chemicals body: the same writable fields. The hub's create route does not filter its
 * body, so this allowlist is the only thing keeping other columns out.
 */
export function toCreateChemicalRequest(fields: ChemicalCreateRequest): ChemicalCreateRequest {
  return toChemicalRequest(fields) as ChemicalCreateRequest;
}
